var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.option.information)?_c('label',{staticClass:"option-tooltip-switch",attrs:{"for":_vm.getIdentifier}},[_c('InfoButton')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }